// Copyright (c) 2025 Cozy Intellect Inc.
// File Path: packages/sharedlib/src/stores/captureFlow.store.ts

import { writable, derived } from 'svelte/store';
import type { Readable } from 'svelte/store';
import type { StepData } from './draftFlow.store';

// Individual stores for each piece of state
export const captureFlowSteps = writable<StepData[]>([]);
export const captureFlowSelectedData = writable<Record<string, any>>({});
export const captureFlowIsComplete = writable<boolean>(false);
export const captureFlowCurrentStepIndex = writable<number>(0);

export const captureFlowCurrentStep: Readable<StepData | null> = derived(
  [captureFlowSteps, captureFlowCurrentStepIndex],
  ([$captureFlowSteps, $captureFlowCurrentStepIndex]) => {
    return $captureFlowSteps?.[$captureFlowCurrentStepIndex] || null;
  }
);

// Helper to reset all stores
export function resetCaptureFlow() {
  captureFlowSteps.set([]);
  captureFlowSelectedData.set({});
  captureFlowIsComplete.set(false);
  captureFlowCurrentStepIndex.set(0);
}

